// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner-container small {
    color: #98BCD5;
    font-weight: bold;
}

.inner-container>div {
    margin-bottom: 20px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm9yZGVyLWRldGFpbC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksY0FBYztJQUNkLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLG1CQUFtQjtBQUN2QiIsImZpbGUiOiJvcmRlci1kZXRhaWwuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5pbm5lci1jb250YWluZXIgc21hbGwge1xuICAgIGNvbG9yOiAjOThCQ0Q1O1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xufVxuXG4uaW5uZXItY29udGFpbmVyPmRpdiB7XG4gICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/secure/orders/order-detail/order-detail.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;AACA,geAAge","sourcesContent":[".inner-container small {\n    color: #98BCD5;\n    font-weight: bold;\n}\n\n.inner-container>div {\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
